<template>
  <v-parallax
    src="@/assets/background.svg"
    height="inherit"
  >
    <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-0 maxw-1750">
      <div
        class="fill-height"
        :style="{ width: '100%'}"
      >
        <v-card elevation="2" class="">
          <v-card-title class="align-center justify-center">
            <!-- <h3>{{ hasSuccess ? this.msgNameSuccess : $t('views.agescon.title') }}</h3> -->
          </v-card-title>

          <v-card-subtitle class="text-center mt-2 text-subtitle-1">
            <template v-if="hasSuccess"> {{this. msgSuccess}} </template>
            <template v-else-if="thereError">
              <div v-if="defaultError" v-html="this.msgError"></div>
              <p v-else>{{this.msgError}} </p>
            </template>
            <template v-else><div v-html="$t('views.agescon.subtitle')" /></template>
          </v-card-subtitle>

          <v-card-text class="text-center justify-center" v-if="!thereError && !hasSuccess">
            <v-row align="center" justify="center" no-gutters>
              <p class="custom-form-field">
                <v-text-field
                  class="mt-2"
                  :label="$t('views.agescon.labelComponent')"
                  :rules="[rules.dmsas]"
                  type="text"
                  name="userDmsas"
                  prepend-icon="mdi-account"
                  v-model="inputDmmsas"
                ></v-text-field>
              </p>
            </v-row>

            <v-row align="center" justify="center" no-gutters class="mt-2">
              <VueRecaptcha
                :loadRecaptchaScript="true"
                :sitekey="$getConst('recaptchaKey')"
                ref="recaptcha"
                @verify="onVerify"
              />
            </v-row>
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn
              v-if="thereError || hasSuccess"
              :to="redirectDependingRoute()"
              color="primary"
            >{{ $t("views.agescon.closeButton") }}</v-btn>

            <v-btn
              v-else
              color="primary"
              v-on:click="submit"
              :loading="form.submitting"
            >{{ $t("views.agescon.labelButton") }}</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </v-parallax>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'PasswordResetView',
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        submitting: false,
        robot: false,
      },
      loadRecaptchaScript: true,
      rules: {
        dmsas: (value) => (value != null && /^[A-Za-z]+\d{2}[A-Za-z]$/.test(value)) || this.$t('validation.dmsas'),
      },
      inputDmmsas: null,
      msgError: null,
      thereError: false,
      hasSuccess: false,
      msgNameSuccess: null,
      msgSuccess: null,
      defaultError: false,
    };
  },
  computed: {
    isMobile() {
      const getter = this.$store.getters['globalState/get'];
      return getter('deviceOS') != null;
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    async submit() {
      if (this.form.robot && this.inputDmmsas) {
        try {
          this.form.submitting = true;
          const response = await this.$api
            .getClient('user')
            .requestUser(this.inputDmmsas);
          this.form.submitting = false;
          const { data } = response;
          if (data && data.code) {
            this.thereError = true;
            if (this.$te(`views.agescon.errors.${data.code}`)) {
              this.msgError = this.$t(`views.agescon.errors.${data.code}`);
            } else {
              this.defaultError = true;
              this.msgError = this.$t('views.agescon.errors.default');
            }
          } else {
            const user = data.collection_cnt.cnt[0];
            this.msgSuccess = this.$t(`views.agescon.finishType.${user.type}`, { destination: user.destination });
            this.msgNameSuccess = this.$t('views.agescon.thanksMessage', { screenname: user.screenname });
            this.hasSuccess = true;
          }
        } catch (error) {
          this.form.submitting = false;
          throw new Error(error);
        }
      }
    },

    onVerify(response) {
      if (response) this.form.robot = true;
      else this.form.robot = false;
    },
    redirectDependingRoute() {
      if (this.isMobile) {
        window.location.href = 'https://ws001.sspa.juntadeandalucia.es/mics/open';
        return '/';
      }
      return (this.$router.currentRoute.path === '/profile/public/passwordreset') ? '/profile/edit' : '/login';
    },

  },
  created() {
    const { passwordExpired } = this.$route.query;

    if (passwordExpired !== undefined && passwordExpired === 'true') {
      this.$store.dispatch('messages/createNotificationMessage', {
        title: 'Contraseña caducada',
        type: 'warning',
        timeout: this.$getConst('notifications.timeoutPlus'),
        dismissible: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  .custom-form-field {
    width: 320px;
  }
</style>
